import { Component, EventEmitter, OnInit, OnDestroy, Output } from '@angular/core';

import { AnonymousSubscription } from 'rxjs/Subscription';
import { KeybindService, KeybindDescription, KEYBOARD_CODES } from '~/core/services';

@Component({
  selector: 'landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, OnDestroy {

  @Output() close: EventEmitter<any> = new EventEmitter();
  subscriptions: AnonymousSubscription[] = [];

  constructor(private keybindService: KeybindService, ) {
    this.subscriptions.push(this.keybindService.bind(new KeybindDescription(KEYBOARD_CODES.escape))
      .subscribe(x => this.onClickedExit()));
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
  }

  onClickedExit() {
    this.close.emit();
  }

  onSearch(searchParams) {
    this.close.emit(searchParams);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/views/landing/landing.component.ts